import { axios } from '@/services/axios';

/**
 * Updates an EightByEight service (e.g. licence entitlements / volumes).
 *
 * PUT /Service/EightByEight
 *
 * @param {object} payload
 * @param {string} payload.id - the EightByEight service ID
 * @param {string} payload.name
 * @param {Array<object>} payload.catalogItems - each
 *   { serviceID, catalogItemID, allowedQuantity, catalogItem }
 * @returns {Promise<object>} the updated EightByEight service definition
 */
const updateEightByEightService = async (payload) => {
    const res = await axios.put('/Service/EightByEight', payload);
    return res.data;
};

export default updateEightByEightService;
